import React, { useRef } from "react";
import { Link } from "react-router-dom";
import { IoAddCircleOutline } from "react-icons/io5";

const AddIcon = IoAddCircleOutline as any;

interface Option {
  to: string;
  title: string;
  description: string;
}

const OPTIONS: Option[] = [
  { to: "/custom-polygon", title: "Custom polygon", description: "Draw a custom polygon on the map." },
  { to: "/polygon-select", title: "Standard polygons", description: "Select from a list of standard polygons." },
  { to: "/road-links", title: "Road links", description: "Select road network segments." },
];

/** The "New area" button and its menu of ways to create an area. Editors only: the caller hides it. */
const NewAreaMenu: React.FC = () => {
  const ref = useRef<HTMLDetailsElement>(null);
  const close = () => ref.current?.removeAttribute("open");

  return (
    <details
      ref={ref}
      className="dropdown dropdown-end"
      onKeyDown={(e) => {
        if (e.key === "Escape") {
          close();
          ref.current?.querySelector("summary")?.focus();
        }
      }}
    >
      <summary className="btn btn-primary btn-sm gap-2 rounded-full">
        <AddIcon className="h-4 w-4" aria-hidden="true" />
        New area
      </summary>
      <ul className="dropdown-content menu z-20 mt-2 w-80 rounded-2xl border border-paper-300/70 bg-surface p-2 shadow-card">
        {OPTIONS.map((opt) => (
          <li key={opt.to}>
            <Link to={opt.to} onClick={close}>
              <span className="flex flex-col">
                <span className="font-semibold text-ink">{opt.title}</span>
                <span className="text-xs text-ink-muted">{opt.description}</span>
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </details>
  );
};

export default NewAreaMenu;
